import { Notification, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';

function TopNotifications({ someSkusUnavailable, product }) {
  return (
    <>
      {someSkusUnavailable && product?.orderable && (
        <Notification
          status="warning"
          isClosable
          message={
            <Typography variant="body2">
              <Trans i18nKey="someVariantsUnavailable" components={{ b: <b /> }} />
            </Typography>
          }
        />
      )}
    </>
  );
}

TopNotifications.propTypes = {
  someSkusUnavailable: PropTypes.bool,
  product: PropTypes.object
};

export { TopNotifications };
